import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from "@angular/core";
import { FetchDataService } from "Services/fetch-data.service";
import { EventService } from "Services/event.service";
import { UserRow } from "Classes/GridRows";
import { ModalConfig } from "Classes/ModalConfig";
declare var $: any;

@Component({
    selector: "edit-info",
    template: require('./edit-info.component.html'),
    styles: [require('./edit-info.component.css')]
})

export class EditInfoComponent implements OnInit, AfterViewInit, OnDestroy {
    constructor(
        private fetchDataService: FetchDataService,
        private eventService: EventService
    ) {
    }

    @Input() editInfo: boolean;
    @Input() selectedUser: UserRow;
    @Output() selectedUserChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() editInfoChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    
    modalConfig: ModalConfig;

    types: any[] = [
        { value: this.fetchDataService.regular, alias: "Regular" },
        { value: this.fetchDataService.admin, alias: "Admin" }
    ];

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        var inputs = $(".edit-info-background-container").find('select, input, textarea, button, a').filter(':visible');
        var firstInput = inputs.first();
        var lastInput = inputs.last();

        /*set focus on first input*/
        $(inputs[1]).focus();

        /*redirect last tab to first input*/
        lastInput.on('keydown', function (e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstInput.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstInput.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastInput.focus();
            }
        });
    }

    ngOnDestroy(): void {
        $(".manage-users-buttons-container").find("button").first().focus();
    }

    unfocusSelectElement() {
        $(".edit-info-form-select").blur();
        $("#form-submit-button").click();
    }

    confirmEditUserInfo(): void {
        this.modalConfig = new ModalConfig(
            "confirm",
            "Warning",
            "Are you sure you want to change this user's information?",
            $(".edit-info-background-container").find('select, input, textarea, button, a').filter(':visible').first(),
            () => { },
            this.editUserInfo.bind(this)
        );
        this.eventService.broadcast(this.eventService._displayModal, this.modalConfig);
    }

    editUserInfo(): void {
        this.selectedUserChange.emit(this.selectedUser);
    }

    cancel(): void {
        this.editInfo = false;
        this.editInfoChange.emit(this.editInfo);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/edit-info.component.ts